import { useSelector } from 'react-redux'

import { sortArrayBy } from '@domain-group/javascript-utils'
import { EntitiesState } from '@redux/entities'

interface EntitySelectBoxProps {
  customEntities?: [],
  entityDisplayKey: string,
  entityKey: string,
  entityValue?: string,
  label?: string,
  sortDirection?: 'asc' | 'desc',
  sortKey: string,
}

interface SortEntitiesParams extends Partial<EntitySelectBoxProps> {
  entities: EntitiesState | [],
}

const sortEntities = (params: SortEntitiesParams) => {
  const { entities, sortDirection, sortKey } = params

  const array = Array.isArray(entities) ? entities : Object.values(entities)
  const sorted = sortArrayBy(array, sortDirection, sortKey as any)

  return sorted
}

const EntitySelectBox = (props: EntitySelectBoxProps) => {
  const {
    customEntities = [],
    entityDisplayKey = 'title',
    entityKey,
    entityValue,
    label,
    sortDirection = 'asc',
    sortKey = 'title',
    ...restProps
  } = props

  // @ts-expect-error TS2339
  const reduxEntities = useSelector(reduxState => reduxState?.entities[entityKey])

  const entities = customEntities.length > 0 ? customEntities : reduxEntities

  if (!entities){
    return null
  }

  const sortedEntities = sortEntities({ entities, sortDirection, sortKey })

  return (
    <select data-validate-field-on="change" {...restProps}>
      <option value="">{label || 'Please Select...'}</option>
      {sortedEntities.map((entity, index) => (
        <option
          // @ts-expect-error TS2339
          key={entity?.id != null ? entity.id : index}
          // @ts-expect-error TS2538
          value={entity[entityValue] != null ? entity[entityValue] : entity?.id}
        >
          {/*
           // @ts-expect-error TS7053 */}
          {entity[entityDisplayKey]}
        </option>
      ))}
    </select>
  )
}

export default EntitySelectBox
